export var SELECT_MODE;
(function (SELECT_MODE) {
    SELECT_MODE["permitted"] = "permitted";
    SELECT_MODE["denied"] = "denied";
})(SELECT_MODE || (SELECT_MODE = {}));
export var CELL_ICON_TYPE;
(function (CELL_ICON_TYPE) {
    CELL_ICON_TYPE["moon"] = "moon";
    CELL_ICON_TYPE["sun"] = "sun";
})(CELL_ICON_TYPE || (CELL_ICON_TYPE = {}));
export var BACKUP_MATRIX_FORMAT;
(function (BACKUP_MATRIX_FORMAT) {
    BACKUP_MATRIX_FORMAT["eu"] = "eu";
    BACKUP_MATRIX_FORMAT["us"] = "us";
})(BACKUP_MATRIX_FORMAT || (BACKUP_MATRIX_FORMAT = {}));
export var CURSOR_EVENT;
(function (CURSOR_EVENT) {
    CURSOR_EVENT["null"] = "null";
    CURSOR_EVENT["onMouseDown"] = "onMouseDown";
    CURSOR_EVENT["onMouseMove"] = "onMouseMove";
    CURSOR_EVENT["onMouseUp"] = "onMouseUp";
})(CURSOR_EVENT || (CURSOR_EVENT = {}));
export var CELL_TYPE;
(function (CELL_TYPE) {
    CELL_TYPE["leftTopCaptionCell"] = "leftTopCaptionCell";
    CELL_TYPE["dayCaptionCell"] = "dayCaptionCell";
    CELL_TYPE["hourCaptionCell"] = "hourCaptionCell";
    CELL_TYPE["mainCell"] = "mainCell";
    CELL_TYPE["other"] = "other";
})(CELL_TYPE || (CELL_TYPE = {}));
//# sourceMappingURL=types.js.map